module.exports = __webpack_public_path__ + "static/media/support.b756d905.png";